export function getUsersAutotradeChannelName(userId : number) {
  return `autotrade.user.${userId}`;
}